import store from "datastore/store";

import fetchCollection from "./fetchCollection";

export default async function fetchTags(businessUid) {
  if (!businessUid) return;
  store.dispatch({ type: "ADD_TAGS_LOADING" });
  let data = await fetchCollection(`tags/business/${businessUid}`);
  data = data.map((section) => {
    let tags = Object.entries(section.tags).map((entry) => {
      // We changed the schema, so do a lil magic here
      const [uid, data] = entry;
      if (typeof data === "string") {
        return { uid, name: data };
      }
      return { uid, ...data };
    });
    return { ...section, tags };
  });
  store.dispatch({ type: "ADD_TAGS_SUCCESS", data });
}
